<div class="container">
  <div class="selected-item" (click)="selectedItemClick()">
    {{selectedItem.value}}
  </div>
  @if (opened) {
    <div class="items-container-wrapper">
      <div class="items-container" (mouseover)="itemsMouseOver()" (mouseout)="itemsMouseOut()">
        @for (it of items; track it) {
          <div (click)="itemClick(it)" [class.selected]="it==selectedItem">
            {{it.value}}
          </div>
        }
      </div>
    </div>
  }
</div>